import _ from 'lodash';
import { Expose, Transform } from 'class-transformer';
import COMPSET_TYPE from '@/modules/compsets/constants/compset-type.constant';
import type RatesSettingsModel from '@/modules/rates/models/rates-settings.model';
import type DocumentFiltersModel from '@/modules/document-filters/models/document-filters.model';
import ANY_MEAL_TYPE from '@/modules/meal-types/constants/any-meal-type.constant';
import ANY_ROOM_TYPE from '@/modules/room-types/constants/any-room-type.constant';

export class TriggerScheduleModel {
    @Expose({ name: 'compset_type' })
    compsetType!: COMPSET_TYPE;

    @Expose()
    los!: number[];

    @Expose()
    pos!: string[];

    @Expose({ name: 'number_of_guests' })
    numberOfGuests!: number[];

    @Expose({ name: 'meal_types' })
    mealTypes!: number[];

    @Expose({ name: 'room_types' })
    roomTypes!: number[];

    @Expose()
    providers!: string[];

    @Expose()
    @Transform((_, filters) => {
        const [los] = filters.los as number[];
        const [pos] = filters.pos as string[];
        const [numberOfGuests] = filters.number_of_guests as number[];
        const [mealTypeId = ANY_MEAL_TYPE.id] = filters.meal_types as number[];
        const [roomTypeId = ANY_ROOM_TYPE.id] = filters.room_types as number[];
        const [provider] = filters.providers as string[];

        return {
            los,
            pos,
            numberOfGuests,
            mealTypeId,
            roomTypeId,
            provider,
        } as Partial<RatesSettingsModel & DocumentFiltersModel>;
    })
    filters!: Partial<RatesSettingsModel & DocumentFiltersModel>;
}
